module.exports = __webpack_public_path__ + "img/right1.88ca8b0a.png";